var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocal = function SvgLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52.5 24.5h-21V8.167h-7V24.5h-21v7h21v16.333h7V31.5h21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.5 8.167h-9.333v10.08L48.113 8.68a7 7 0 0 0-2.613-.513M36.167 47.833H45.5c.933 0 1.797-.186 2.613-.513l-11.946-9.567zM10.5 47.833h9.333v-10.08L7.887 47.32c.816.327 1.68.513 2.613.513M52.5 19.833v-4.666a6.87 6.87 0 0 0-.863-3.314l-9.987 7.98zM41.65 36.167l9.987 7.98c.536-.98.863-2.1.863-3.314v-4.666zM3.5 36.167v4.666c0 1.214.327 2.334.863 3.314l9.987-7.98zM14.35 19.833l-9.963-7.98c-.537.98-.864 2.1-.864 3.314v4.666h10.85zM19.833 8.167H10.5c-.933 0-1.797.186-2.613.513l11.946 9.567z"
  })));
};
export default SvgLocal;